@if (treasury.isLoadedToday()) {
  <div class="tstatus tstatus--ok" role="status">
    <i class="pi pi-check-circle" aria-hidden="true"></i>
    <span class="tstatus__text">
      <strong>Treasury rates loaded for today.</strong> You're ready to run reports.
    </span>
    <a class="tstatus__link" routerLink="/treasury-rates">View rates</a>
    <a class="tstatus__link" routerLink="/treasury">Re-fetch</a>
  </div>
} @else {
  <div class="tstatus tstatus--warn" role="status">
    <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
    <span class="tstatus__text">
      <strong>Step 1: Load today's Treasury rates.</strong>
      Reports price off the latest Treasury yield curve — load it before running any report.
    </span>
    <a class="tstatus__link" routerLink="/treasury-rates">View rates</a>
    <a class="tstatus__cta" routerLink="/treasury">
      Load Treasury rates <i class="pi pi-arrow-right" aria-hidden="true"></i>
    </a>
  </div>
}
